import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import _isFunction from "lodash/isFunction";
import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, Button, Dropdown, CheckButton, showSuccess } from 'components';
import { getCompanyData, addBorrowerWorkingPlace, editBorrowerWorkingPlace } from 'services';
import { showApiError, digitsOnlyPattern } from 'utils';
import { paycheckPaymentTypesNameSelect } from 'enums';
import { searchBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var montDaysOptions = _toConsumableArray(Array(31)).map(function (e, i) {
  return {
    label: "".concat(i + 1),
    value: i + 1
  };
});

var workExperienceYearsOptions = _toConsumableArray(Array(99)).map(function (e, i) {
  return {
    label: "".concat(i, " \u0433\u043E\u0434\u0438\u043D\u0438"),
    value: i + 1
  };
});

var workExperienceMonthsOptions = _toConsumableArray(Array(12)).map(function (e, i) {
  return {
    label: "".concat(i, " \u043C\u0435\u0441\u0435\u0446\u0430"),
    value: i
  };
});

var BorrowerWorkPlaceForm = function BorrowerWorkPlaceForm(_ref) {
  var _data$company, _data$company2, _data$company3;

  var data = _ref.data,
      idNumber = _ref.idNumber,
      onBorrowerChange = _ref.onBorrowerChange,
      onCancel = _ref.onCancel;

  var initialData = _objectSpread(_objectSpread({}, data), {}, {
    identifier: data === null || data === void 0 ? void 0 : (_data$company = data.company) === null || _data$company === void 0 ? void 0 : _data$company.identifier,
    name: data === null || data === void 0 ? void 0 : (_data$company2 = data.company) === null || _data$company2 === void 0 ? void 0 : _data$company2.name,
    address: data === null || data === void 0 ? void 0 : (_data$company3 = data.company) === null || _data$company3 === void 0 ? void 0 : _data$company3.address,
    discretion: (data === null || data === void 0 ? void 0 : data.discretion) === 1
  });

  var handleIdentifier = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formProps) {
      var mergedValues, setValues, _yield$getCompanyData, _yield$getCompanyData2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              mergedValues = formProps.mergedValues, setValues = formProps.setValues;
              _context.next = 3;
              return getCompanyData(mergedValues === null || mergedValues === void 0 ? void 0 : mergedValues.identifier);

            case 3:
              _yield$getCompanyData = _context.sent;
              _yield$getCompanyData2 = _slicedToArray(_yield$getCompanyData, 2);
              res = _yield$getCompanyData2[0];
              err = _yield$getCompanyData2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 9:
              setValues(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  name: res === null || res === void 0 ? void 0 : res.summary,
                  address: res === null || res === void 0 ? void 0 : res.details
                });
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleIdentifier(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
      var values, isEdited, body, method, params, _yield$method, _yield$method2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = _ref3.values, isEdited = _ref3.isEdited;
              body = {
                company: _objectSpread(_objectSpread({}, (values === null || values === void 0 ? void 0 : values.id) && {
                  id: values === null || values === void 0 ? void 0 : values.id
                }), {}, {
                  name: values === null || values === void 0 ? void 0 : values.name,
                  identifier: values === null || values === void 0 ? void 0 : values.identifier,
                  address: values === null || values === void 0 ? void 0 : values.address
                }),
                position: values === null || values === void 0 ? void 0 : values.position,
                paycheck_date: values === null || values === void 0 ? void 0 : values.paycheck_date,
                paycheck_payment_method: values === null || values === void 0 ? void 0 : values.paycheck_payment_method,
                work_experience_months: values === null || values === void 0 ? void 0 : values.work_experience_months,
                work_experience_years: values === null || values === void 0 ? void 0 : values.work_experience_years,
                work_experience_in_company_months: values === null || values === void 0 ? void 0 : values.work_experience_in_company_months,
                work_experience_in_company_years: values === null || values === void 0 ? void 0 : values.work_experience_in_company_years,
                discretion: values !== null && values !== void 0 && values.discretion ? 1 : 0
              };

              if (!isEdited) {
                _context2.next = 18;
                break;
              }

              method = data ? editBorrowerWorkingPlace : addBorrowerWorkingPlace;
              params = data ? [data === null || data === void 0 ? void 0 : data.id, body] : [idNumber, body];
              _context2.next = 7;
              return method.apply(void 0, params);

            case 7:
              _yield$method = _context2.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context2.next = 14;
                break;
              }

              showApiError(err);
              return _context2.abrupt("return", true);

            case 14:
              showSuccess("\u041C\u0435\u0441\u0442\u043E\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u0430 ".concat(data ? 'редактирана' : 'добавена', " \u0443\u0441\u043F\u0435\u0448\u043D\u043E."));
              _isFunction(onBorrowerChange) && onBorrowerChange(res);
              _context2.next = 19;
              break;

            case 18:
              _isFunction(onCancel) && onCancel();

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: initialData
  }, ___EmotionJSX(Row, {
    horizontalGap: 8,
    verticalGap: 8,
    align: "center"
  }, ___EmotionJSX(Col, {
    md: true
  }, ___EmotionJSX(Input, {
    pattern: digitsOnlyPattern,
    formId: "identifier",
    label: "\u0415\u0418\u041A"
  })), ___EmotionJSX(Col, {
    md: "auto"
  }, function (formProps) {
    return ___EmotionJSX(Button, {
      css: searchBtn,
      small: true,
      leftIcon: {
        iconName: 'la la-search'
      },
      onClick: function onClick() {
        return handleIdentifier(formProps);
      }
    });
  })), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "name",
    label: "\u0418\u043C\u0435 \u043D\u0430 \u0444\u0438\u0440\u043C\u0430\u0442\u0430"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    type: "textarea",
    formId: "address",
    label: "\u0410\u0434\u0440\u0435\u0441 \u043D\u0430 \u0444\u0438\u0440\u043C\u0430\u0442\u0430"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "position",
    label: "\u0414\u043B\u044A\u0436\u043D\u043E\u0441\u0442"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "paycheck_date",
    label: "\u0417\u0430\u043F\u043B\u0430\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430 \u043D\u0430",
    options: montDaysOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "paycheck_payment_method",
    label: "\u041F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u0437\u0430\u043F\u043B\u0430\u0442\u0430",
    options: paycheckPaymentTypesNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "work_experience_years",
    label: "\u041E\u0431\u0449\u043E \u0442\u0440\u0443\u0434\u043E\u0432 \u0441\u0442\u0430\u0436 \u0433\u043E\u0434.",
    options: workExperienceYearsOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "work_experience_months",
    label: "\u041E\u0431\u0449\u043E \u0442\u0440\u0443\u0434\u043E\u0432 \u0441\u0442\u0430\u0436 \u043C\u0435\u0441.",
    options: workExperienceMonthsOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "work_experience_in_company_years",
    label: "\u0421\u0442\u0430\u0436 \u0432\u044A\u0432 \u0444\u0438\u0440\u043C\u0430 \u0433\u043E\u0434.",
    options: workExperienceYearsOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(Dropdown, {
    formId: "work_experience_in_company_months",
    label: "\u0421\u0442\u0430\u0436 \u0432\u044A\u0432 \u0444\u0438\u0440\u043C\u0430 \u043C\u0435\u0441.",
    options: workExperienceMonthsOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(CheckButton, {
    formId: "discretion"
  }, "\u0414\u0438\u0441\u043A\u0440\u0435\u0442\u043D\u043E\u0441\u0442"))), ___EmotionJSX(Row, {
    horizontalGap: 8,
    verticalGap: 8,
    justify: "flex-end"
  }, ___EmotionJSX(Col, {
    sm: "auto"
  }, function (_ref5) {
    var onSubmit = _ref5.onSubmit;
    return ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0417\u0430\u043F\u0430\u0437\u0438");
  }))));
};

BorrowerWorkPlaceForm.propTypes = {
  idNumber: PropTypes.string,
  onBorrowerChange: PropTypes.func,
  onCancel: PropTypes.func,
  data: PropTypes.object
};
export default BorrowerWorkPlaceForm;